import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import OperacaoFiscalService from 'business/cadastro/fiscal/operacaoFiscal/operacaoFiscalService'
import FormList from 'base/FormList'

export default function OperacaoFiscalList() {

    const [service] = useState(() => new OperacaoFiscalService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_opefis',
        dsName: 'descricao_opefis',
        mainField: { name: 'descricao_opefis', label: 'Descrição' },
        advFields: [
            { name: 'codigo_opefis', label: 'Código', type: 'integer', inputMode: 'numeric' },
            { name: 'descricao_opefis', label: 'Descrição', type: 'string', inputMode: 'text' },
            { name: 'descricao_tri', label: 'Tributo', type: 'string', inputMode: 'text' },
            { name: 'sigla_tri', label: 'Sigla do tributo', type: 'string', inputMode: 'text' },
            { name: 'ncms_opefis', label: 'NCMs (Ex: 87,4200)', type: 'string', inputMode: 'text' },
            { name: 'cests_opefis', label: 'CESTSs (Ex: 87,4200)', type: 'string', inputMode: 'text' },
            { name: 'codigo_ben_fiscal_opefis', label: 'Código do benefício fiscal', type: 'string', inputMode: 'text' },
            { name: 'edita_opefis', label: 'Editável', type: 'boolean', component: 'TriStateCheckbox', value: null },
            { name: 'eh_fora_pais_clifor_opefis', label: 'Cli/for é fora do país', type: 'boolean', component: 'TriStateCheckbox', value: null },
            { name: 'eh_fora_uf_clifor_opefis', label: 'Cli/for é fora do estado', type: 'boolean', component: 'TriStateCheckbox', value: null },
            { name: 'eh_fora_muni_clifor_opefis', label: 'Cli/for é fora da cidade', type: 'boolean', component: 'TriStateCheckbox', value: null },
            { name: 'eh_zfm_clifor_opefis', label: 'Zona franca de manaus', type: 'boolean', component: 'TriStateCheckbox', value: null },
            { name: 'eh_inventario_opefis', label: 'Inventário', type: 'boolean', component: 'TriStateCheckbox', value: null },
            { name: 'eh_prod_defeito_opefis', label: 'Produto defeituoso', type: 'boolean', component: 'TriStateCheckbox', value: null },
            { name: 'eh_contrib_icms_clifor_opefis', label: 'Cli/for Contribuinte (ICMS)', type: 'boolean', component: 'TriStateCheckbox', value: null },
            { name: 'mva_icms_esp_clifor_opefis', label: 'MVA-ICMS especial', type: 'boolean', component: 'TriStateCheckbox', value: null },
            { name: 'eh_presencial_opefis', label: 'Operação presencial', type: 'boolean', component: 'TriStateCheckbox', value: null },
            { name: 'eh_emiss_propria_opefis', label: 'Emissão própria', type: 'boolean', component: 'TriStateCheckbox', value: null },
            { name: 'obs_nf_imp_opefis', label: 'Sempre imprimir a observação na nota fiscal', type: 'boolean', component: 'TriStateCheckbox', value: null },
            { name: 'obs_nf_fisco_opefis', label: 'A observação é de interesse do fisco', type: 'boolean', component: 'TriStateCheckbox', value: null },
            { name: 'cumul_opefis', label: 'Cumulativo', type: 'boolean', component: 'TriStateCheckbox', value: null },
            { name: 'st_ret_calc_opefis', label: 'Calcular retenção de ST', type: 'boolean', component: 'TriStateCheckbox', value: null },
            { name: 'efet_calc_opefis', label: 'Calcular imposto efetivo', type: 'boolean', component: 'TriStateCheckbox', value: null },
            { name: 'mov_estoque_opefis', label: 'Movimenta estoque', type: 'boolean', component: 'TriStateCheckbox', value: null },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="codigo_opefis" sortable header="Código"></Column>
            <Column field="meta.descricao_tri" sortable header="Tributo" style={{ whiteSpace: 'normal' }}></Column>
            <Column field="meta.sigla_tri" sortable header="Sigla"></Column>
            <Column field="descricao_opefis" sortable header="Descrição" style={{ whiteSpace: 'normal' }}></Column>
        </FormList >
    )
}
